export function formatString(str) {
  return (
    str
      ?.replace(/\//g, "")
      // Add space between numbers and letters/units
      .replace(/(\d)([A-Za-z])/g, "$1 $2")
      // Add space between currency symbols and numbers (exclude dots and commas)
      .replace(/([^\d\s.,])(\d)/g, "$1 $2")
  );
}
